import { Injectable } from '@angular/core';
import {BaseService} from "./base.service";
import {FinishModel, PaginationModel, RequestParamModel} from "@coreModels";
import {ApiConstants} from "@coreConstant";
import {catchError, map} from "rxjs/operators";
import {HttpResponse} from "@angular/common/http";
import {throwError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FinishService {

  constructor(
    private baseService: BaseService
  ) { }

  /**
   *  Get all family list
   * @param requestParamModel
   * @returns
   */
  getFinishes(requestParamModel?: RequestParamModel) {
    return this.baseService.get(ApiConstants.FINISH_LIST_URL, requestParamModel).pipe(
      map((response: HttpResponse<any>) => {
        const finishLists = new PaginationModel<FinishModel>();
        const headers = response.headers;
        finishLists.setHeaders(headers);
        finishLists.data = response.body.data as FinishModel[]; // Make sure this line reflects the correct data structure
        return finishLists;
      }),
      catchError((error: unknown) => {
       return throwError(() => new Error('Failed to fetch finish data'));
      })
    );
  }
}
